import { render, staticRenderFns } from "./BulkInsertUpdateAssign.vue?vue&type=template&id=6fa27ca0&scoped=true&"
import script from "./BulkInsertUpdateAssign.vue?vue&type=script&lang=js&"
export * from "./BulkInsertUpdateAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa27ca0",
  null
  
)

export default component.exports